import { useCallback, useState } from 'react'

interface IInitState<T> {
  data: Array<T>
  search: string
  order: any
  sortOrder: 'ASC' | 'DESC'
  page: number
  hasMore: boolean
  [key: string]: any
}

interface IProps<T> {
  initState?: IInitState<T>
}

const usePaginationList = <T extends unknown>(props: IProps<T> = {}) => {
  const { initState } = props
  const defaultState: IInitState<T> =
    initState || {
      data: [],
      search: '',
      order: '',
      sortOrder: 'DESC',
      page: 0,
      hasMore: true,
    }

  const [pagination, setPagination] = useState<IInitState<T>>(defaultState)

  const handleSearch = useCallback((search) => {
    setPagination((prevState) => ({
      ...prevState,
      data: prevState.search !== search ? [] : prevState.data,
      page: 0,
      search: search,
    }))
  }, [])

  const handleSort = useCallback((order, orderSor) => {
    setPagination((prevState) => ({
      ...prevState,
      page: 0,
      data: [],
      order: order,
      sortOrder: orderSor,
    }))
  }, [])

  const handleFetchMore = useCallback(() => {
    setPagination((prevState) => ({
      ...prevState,
      page: prevState.page + 1,
    }))
  }, [])

  const handleRefresh = useCallback(() => {
    setPagination((prevState) => ({
      ...prevState,
      data: [],
      page: 0,
      hasMore: true,
    }))
  }, [])

  return {
    pagination,
    handleFetchMore,
    handleSort,
    handleSearch,
    handleRefresh,
    setPagination,
  }
}

export { usePaginationList }
